// extracted by mini-css-extract-plugin
module.exports = {"hide":"pagination_hide__pfcIy","pagination":"pagination_pagination__2hnnq","selected":"pagination_selected__4NcQR"};